import { useContext } from "react";
import type { Services } from "@/lib/services";
import { ServicesContext } from "./services-context";

/** The wired services. Throws outside the provider so a missing wrapper fails loudly. */
export function useServices(): Services {
  const services = useContext(ServicesContext);
  if (!services) throw new Error("useServices must be used inside <ServicesProvider>");
  return services;
}
